import storage from "redux-persist/lib/storage";

export const persistConfig = {
  key: "root",
  storage,
  whitelist: ["category"],
};
export const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["isAuthInitialized", "user",],
};
